import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const ChartHeaderContainer = styled(Box).attrs({
  py: { sm: '450' },
  justifyContent: { sm: 'flex-start' },
  alignItems: { sm: 'center' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[200]};
  height: ${({ theme }) => theme.spacings[900]};
  width: 100%;
`;

export const ErrorContainer = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  alignItems: { sm: 'center' },
})`
  height: 100%;
  /* ErrorRetry control not to expand full width of screen */
  & > :first-child {
    flex-grow: 0 !important;
  }
`;

export const TooltipContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: 1 },
  p: { sm: '400' },
})`
  min-width: 100px;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.grey[200]};
    border-radius: ${theme.spacings[200]};
    box-shadow: ${theme.spacings[100]} ${theme.spacings[100]} ${theme.colors.grey[300]};
  `}
`;
